import {z} from 'zod';
export interface AMCompanyModel {
  companyId: string;
  id: string;
  title: string,
  description?: string,
  type: AMCompanyModelType
  fileIdentifier: string,
  createdAt: number,
  modifiedAt?: number,
}

export const AmCompanyModelTypeEnum = z.enum(["SPV", "Project", "Debt-Funding", "PFA"]);
type AMCompanyModelType = z.infer<typeof AmCompanyModelTypeEnum>;